import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {},
  },
  pt: {
    translation: {
      REGISTER_NEW_USER: "CADASTRAR NOVO USUÁRIO",
      Number_of_Farms: "QTD Fazendas",
      Localazation: "Localização",
      Institution: "Instituição",
      Never_accessed: "Nunca acessou",
      Last_Acess: "Último acesso",
      Phone: "Telefone",
      ENTITLEMENT_1: "Juntos, transformando mercados.",
      ENTITLEMENT_2: "Tenho um convite",
      ENTITLEMENT_3: "Acesso",
      ENTITLEMENT_4: "Esqueci minha senha",
      ENTITLEMENT_5: "Recuperar senha",
      ENTITLEMENT_6: "Informe seu e-mail cadastrado para recuperar sua senha",
      ENTITLEMENT_7:
        "Enviaremos um código de verificação para que você posso cirar uma nova senha de acesso",
      ENTITLEMENT_8: "Recuperar senha",
      ENTITLEMENT_9: "Crie sua nova senha de acesso",
      ENTITLEMENT_10: "Confirmar Cadastro",
      ENTITLEMENT_11:
        "Enviamos um código de acesso. Verifique sei email e insiera o código no campo abaixo para completar seu cadastro",
      ENTITLEMENT_12: "Alterar senha",

      USERS_1: "Usuários",
      USERS_2: "Produtores",
      USERS_3: "Técnicos de Campo",
      USERS_4: "Usuários admnistrativos",
      USERS_5: "Total de Produtores",
      USERS_6: "Total de técnicos",
      USERS_7: "Total de admnistradores",
      USERS_8: "Cadastrar novo administrador",
      USERS_9: "Cadastrar técnico de campo",
      USERS_10: "Permissões de acesso",
      USERS_11: "Dados cadastrais",
      USERS_12: "Permissões de acesso",

      Numeric_Code: "Código",
      Numeric_Code_is_required: "O código é obrigatório",
      Password_Should_Contain_At_Least_1_Number:
        "A senha deve conter no mínimo 1 caracter",
      Invalid_Email: "Email inválido",

      Password_Least8: "A senha deve conter no minimo 8 caracteres",

      Confirm_Password: "Confirmação de Senha",
      Change: "Alterar",
      Confirm_Password_is_required:
        "É necessário informar a confirmação da senha",
      Passwords_must_match: "As senhas não conferem",
      Password_Should_Contain_At_Least_1_Special_Character:
        "A senha deve conter ao menos um caracter especial",
      Password_Should_Contain_At_Least_1_Lowercase:
        "A senha deve conter ao menos uma letra minuscula",
      Password_Should_Contain_At_Least_1_Uppercase:
        "A senha deve conter ao menos uma letra maiuscula",

      Search: "Pesquisar",
      Actions: "Ações",
      Gotoback: "Voltar",
      Login: "Acesso",
      Farms: "Propriedades",
      Farm: "Propriedade",
      Exit: "Sair",
      ChangePassword: "Trocar Senha",
      To_Enter: "Entrar",
      Email_is_required: "Email é obrigatório",
      Password_is_required: "Senha é obrigatória",
      Password: "Senha",
      Name_APP: "Acelerador de Agroflorestas e Restauração",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "pt",
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
